module.exports = __webpack_public_path__ + "static/img/test.3f34e7e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/test.svg
// module id = Lgi0
// module chunks = 1